import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

// Configure axios to include credentials (cookies) in all requests
axios.defaults.withCredentials = true;

/**
 * API service for escheatment operations
 */

export const authenticate = async (
  requestBody = {},
  tenantSlug,
  recaptchaToken = ''
) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };

    // Add reCAPTCHA token to headers if provided
    if (recaptchaToken) {
      headers['x-recaptcha'] = recaptchaToken;
    }

    const response = await axios.post(
      `${API_BASE_URL}/api/${tenantSlug}/verification`,
      requestBody,
      {
        headers,
        withCredentials: true, // Enable sending/receiving cookies
      }
    );
    
    // Extract JWT token from Authorization header
    const jwtToken = response.headers['authorization'] || response.headers['Authorization'];
    
    // Return both response and JWT token
    return {
      ...response,
      jwtToken,
    };
  } catch (error) {
    console.error('Error Authenticating:', error?.message);
    throw error;
  }
};

export const requestCheque = async (requestBody = {}, tenantSlug, jwtToken = '') => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };

    // Add JWT token to Authorization header if provided
    if (jwtToken) {
      // Ensure the token has 'Bearer ' prefix if not already present
      const authToken = jwtToken.startsWith('Bearer ') ? jwtToken : `Bearer ${jwtToken}`;
      headers['Authorization'] = authToken;
    }

    const response = await axios.post(
      `${API_BASE_URL}/api/${tenantSlug}/request/check`,
      requestBody,
      {
        headers,
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    console.error('Error Requesting Cheque:', error?.message);
    throw error;
  }
};
